export default {
  slots: {
    heading: 'first-letter:capitalize',
  },
}